import { faChevronDown, faGlobe } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import React from 'react'
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native'
import { white } from '../../theme/colors'
import { useTranslation } from 'react-i18next'
import i18n from '../../translations/i18n'
import { DOBRA } from '../../theme/fonts'
export const ChangeLanguage = () => {
  const { t } = useTranslation()

  const changeLanguage = () => {
    i18n
      .changeLanguage(i18n.language === 'en' ? 'es' : 'en')
      .then(() => {})
      .catch((err) => console.error(err))
  }
  return (
    <View style={styles.languageSwitchContainer}>
      <TouchableOpacity style={styles.option} onPress={changeLanguage}>
        <View style={styles.iconContainer}>
          <FontAwesomeIcon icon={faGlobe} size={15} color={white} />
        </View>
        <View style={styles.iconContainer}>
          <Text style={styles.text}>{t(i18n.language === 'es' ? 'Español' : 'Inglés')}</Text>
        </View>
        <View style={styles.iconContainer}>
          <FontAwesomeIcon icon={faChevronDown} size={15} color={white} />
        </View>
      </TouchableOpacity>
    </View>
  )
}
const styles = StyleSheet.create({
  languageSwitchContainer: {
    paddingVertical: 12,
  },
  option: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  iconContainer: {
    padding: 5,
    alignItems: 'center',
  },
  text: {
    fontFamily: DOBRA,
    fontSize: 13,
    color: '#FFFEFE',
  },
})
